<template>
  <div class="c-app">
    <CModal
      :title="warningTitle"
      color="warning"
      :show.sync="warningModal"
      @update:show="closeModal"
      :closeOnBackdrop="false"            
    >
      {{warningMessage}}      
    </CModal>
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import EventBus from '../services/EventBus'
import Mgr from '../services/SecurityService'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  data() {
    return {
      warningMessage:'',
      warningTitle: '',
      warningModal: false,
      mgr: new Mgr(),
    };
  },
  mounted() {
    EventBus.$on('ACCESS_TOKEN_EXPIRED',() => {
      //
      this.warningMessage = 'Session Timeout';
      this.warningTitle = 'Warning';
      this.warningModal = true;
      
    });
  },
  methods: {
    closeModal(value, event) {
      let self = this;
     console.log(value, event);
      if (value === false)
        self.mgr.redirectLogin()
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
